// extracted by mini-css-extract-plugin
module.exports = {"workorder-container":"style_workorder-container__2CAfw"};